import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

export default function RiskBadge({ level }) {
  const styles = {
    CRITICAL: "bg-red-50 text-red-700 border-red-200",
    HIGH: "bg-orange-50 text-orange-700 border-orange-200",
    MEDIUM: "bg-amber-50 text-amber-700 border-amber-200"
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-bold tracking-wider uppercase border ${styles[level] || styles.MEDIUM}`}>
      <FiAlertTriangle size={12} />
      {level} RISK
    </span>
  );
}